const Merchant = [
  {
    path: '/customer/merchant-files-upload',
    name: 'merchant_files',
    component: () => import(/* webpackChunkName: "merchant" */'./views/MerchantFiles.vue'),
    meta: {
      requiresAuth: true,
      title: 'AlgoStack Analytics Merchant Files',
      breadCrumbs: [
        {
          name: 'Merchant File Uploads',
          path: '#',
        },
      ],
    },
    children: [],
  },
];

export default Merchant;
